
import Footer from "./Footer";
import Navbar from "./Navbar";

import LoanCalculator from "./LoanCalculator";
import WhyChooseUs from "./WhyChooseUs";
import LoanEligibility from "./LoanEligibility";
import DocumentsRequired from "./DocumentsRequired";
import RepresentativeExample from "./RepresentativeExample";
import HowItWorks from "./HowItWorks";
import Testimonials from "./Testimonials";
import BlogSection from "./BlogSection";
import AboutUs from "./AboutUs";
import SecurityNotice from "./SecurityNotice";
import AnimatedCounter from "./AnimatedCounter";
import mslMascot from "../assets/mslmasot1.png";

function PaisaPopLanding() {

  return (
    <div className="w-full overflow-x-hidden bg-[#EFFFFD]">
      <Navbar />
      
      {/* Hero Section */}
      <section id="home" className="w-full pt-16 bg-[#EFFFFD]">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-10 lg:py-12 overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[minmax(0,1.45fr)_minmax(0,1fr)] gap-8 lg:gap-12 items-center bg-[#EFFFFD]">
            {/* Left Content */}
            <div className="relative z-20 w-full max-w-[675px] flex flex-col justify-center gap-5 bg-[#EFFFFD]">
              <p className="text-gray-600 text-sm font-medium font-['Inter'] animate-fade-in-up">
                Apply online. Get approved faster. Funds credited to your bank.
              </p>
              
              <h1 className="w-full max-w-[675px] text-3xl md:text-4xl lg:text-5xl xl:text-[60px] font-bold leading-[1.1] text-[#2C3E50] font-['Inter'] animate-fade-in-up animate-delay-100">
                <span className="lg:whitespace-nowrap">When expenses don't</span>{" "}<br className="hidden lg:block" />
                wait,{" "}
                <span className="text-[#21A6B5]">
                  <span className="lg:whitespace-nowrap">My Salary Loan</span>{" "}
                  <br className="hidden lg:block" />
                  offers quick and easy loans.
                </span>
              </h1>
              
              <p className="text-gray-700 text-lg md:text-[20px] leading-[1.4] font-normal font-['Inter'] mb-2 animate-fade-in-up animate-delay-200">
                Instant personal loans for salaried professionals transparent, paperless, and built for real-life needs.
              </p>
              
              <div className="flex flex-wrap gap-3 md:gap-4 animate-fade-in-up animate-delay-300">
                <a
                  href={import.meta.env.VITE_WEBSITE_LINK}
                  target="_blank"
                  className="px-6 md:px-8 py-3 md:py-3.5 rounded-full bg-[#3D4A7C] text-white font-semibold hover:bg-[#2d3a6c] transition-colors shadow-md text-sm md:text-base font-['Inter'] hover:scale-105 animate-pulse-glow"
                >
                  Apply Now
                </a>
                <button 
                  onClick={() => {
                    const eligibilitySection = document.getElementById('loan-eligibility');
                    eligibilitySection?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="px-6 md:px-8 py-3 md:py-3.5 rounded-full border-2 border-[#2C3E50] text-[#2C3E50] font-semibold hover:bg-gray-50 transition-colors text-sm md:text-base font-['Inter'] hover:scale-105"
                >
                  Check Eligibility
                </button>
              </div>
            </div>
            
            {/* Right Content - Mascot with background */}
            <div className="relative flex justify-center items-end w-full h-[320px] md:h-[380px] lg:h-[460px] bg-[#EFFFFD]">
              {/* Dashed Outline Half Circle */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[320px] h-[160px] md:w-[340px] md:h-[170px] lg:w-[480px] lg:h-[240px] border-3 border-dashed border-[#7DD4D0] rounded-t-full" style={{ strokeDasharray: '40 40' }}></div>
              
              {/* Gradient Half Circle */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[260px] h-[130px] md:w-[280px] md:h-[140px] lg:w-[420px] lg:h-[210px] bg-gradient-to-br from-[#21A6B5] via-[#7DD4D0] to-[#A9F9EE] rounded-t-full"></div>
              
              {/* Mascot Image */}
              <div className="relative z-10 w-full h-full flex justify-center items-end">
                <img
                  src={mslMascot}
                  alt="My Salary Loan Mascot"
                  className="h-full w-auto max-w-full object-contain object-bottom drop-shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Stats Strip */}
      <section className="w-full bg-gradient-to-r from-[#A9F9EE] via-[#7DD4D0] to-[#21A6B5] py-10 md:py-14 lg:py-16 relative overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-float"></div>
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#3D4A7C] rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-float" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10 lg:gap-12 text-center">
            <div className="group border-r-2 border-[#3D4A7C]/20 last:border-r-0 transition-all hover:scale-110 cursor-pointer py-4 relative">
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="inline-block mb-2">
                  <span className="text-5xl animate-float">🕐</span>
                </div>
                <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B2F7B] font-['Inter'] mb-2 group-hover:scale-110 transition-transform duration-300">24/7</h3>
                <p className="text-[#1B2F7B] font-semibold text-xs md:text-sm lg:text-base font-['Inter'] group-hover:text-white transition-colors duration-300">Online Support</p>
              </div>
            </div>
            <div className="group border-r-2 border-[#3D4A7C]/20 lg:border-r-2 transition-all hover:scale-110 cursor-pointer py-4 relative">
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="inline-block mb-2">
                  <span className="text-5xl animate-float" style={{ animationDelay: '0.5s' }}>✅</span>
                </div>
                <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B2F7B] font-['Inter'] mb-2 group-hover:scale-110 transition-transform duration-300">
                  <AnimatedCounter end={99.9} decimals={1} suffix="%" />
                </h3>
                <p className="text-[#1B2F7B] font-semibold text-xs md:text-sm lg:text-base font-['Inter'] group-hover:text-white transition-colors duration-300">Approval Rate</p>
              </div>
            </div>
            <div className="group border-r-2 border-[#3D4A7C]/20 last:border-r-0 lg:border-r-2 transition-all hover:scale-110 cursor-pointer py-4 relative">
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="inline-block mb-2">
                  <span className="text-5xl animate-float" style={{ animationDelay: '1s' }}>⚡</span>
                </div>
                <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B2F7B] font-['Inter'] mb-2 group-hover:scale-110 transition-transform duration-300">
                  <AnimatedCounter end={3} suffix="X" />
                </h3>
                <p className="text-[#1B2F7B] font-semibold text-xs md:text-sm lg:text-base font-['Inter'] group-hover:text-white transition-colors duration-300">Faster Access</p>
              </div>
            </div>
            <div className="group transition-all hover:scale-110 cursor-pointer py-4 relative">
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="inline-block mb-2">
                  <span className="text-5xl font-bold text-[#1B2F7B] animate-float" style={{ animationDelay: '1.5s' }}>₹</span>
                </div>
                <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B2F7B] font-['Inter'] mb-2 group-hover:scale-110 transition-transform duration-300">
                  <AnimatedCounter end={1} suffix="M+" />
                </h3>
                <p className="text-[#1B2F7B] font-semibold text-xs md:text-sm lg:text-base font-['Inter'] group-hover:text-white transition-colors duration-300">Disbursed Monthly</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EMI Calculator */}
      <LoanCalculator />

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* Loan Eligibility */}
      <LoanEligibility />

      {/* Documents Required */}
      <DocumentsRequired />

      {/* Representative Example */}
      <RepresentativeExample />

      {/* How It Works */}
      <HowItWorks />

      {/* Testimonials */}
      <Testimonials />

      {/* Blog Section */}
      <BlogSection />

      {/* About Us */}
      <AboutUs />

      {/* Security Notice */}
      <SecurityNotice />

      {/* Other Sections */}
      <div className="flex w-full flex-col items-center justify-center gap-16 px-4 py-16 bg-[#EFFFFD]">
      
        <Footer />
      </div>
    </div>
  );
}

export default PaisaPopLanding;
